/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./adssources/js/gift-product.js ***!
  \***************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

window.count_item = window.themeVariables.settings.cartCount;
var cartItems = window.themeVariables.settings.cartItems;
var cartTotalPrice = window.themeVariables.settings.cartTotalPrice;
var isCartPage = window.location.href.indexOf('cart') > -1 ? true : false;
var freeGiftCookiesFirst = "perlgift-1";
var freeGiftCookiesLast = "perlgift-2";
$(document).ready(function () {
  removeGiftProductIfTotalPriceNull();

  if (isCartPage == false) {
    updateCartDrawerForGiftProduct();
  }

  checkCookies(freeGiftCookiesFirst);
  checkCookies(freeGiftCookiesLast);
}); ////////////////////////////////////////////////
//////// CartDrawer ///////////////////////////
// Add / Delete gift Product cart Drawer

function updateCartDrawerForGiftProduct() {
  //first case update the cart 
  document.addEventListener("cart:updated", function (event) {
    // Bei Cart Drawer wird window object leider ohne reload nicht geladen!
    if (window.count_item == 0) {
      location.reload();
    } //check if the client is set a first product for gift


    if (window.count_item > 0 && window.themeVariables.settings.productFirstAvailible.id) {
      var cart = event.detail.cart; // Get the updated content of the cart

      window.count_item = cart.item_count; // update cart items

      var minimum_amount_one = parseFloat(window.themeVariables.settings.productMinumumAmountOne) * 100;
      var minimum_amount_two = parseFloat(window.themeVariables.settings.productMinumumAmountTwo) * 100; //check if the total price greather than to minimum amount and the gift product doesn't exist in the cart

      if (getCookieValue(freeGiftCookiesFirst) != 0 && cart.total_price >= minimum_amount_one && cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) == null) {
        // Please remove the Product first
        var GiftDataRemove = {
          id: "" + parseFloat(window.themeVariables.settings.productFirstAvailible.id),
          quantity: 0
        };
        setProductOperation(window.themeVariables.routes.cartAddUrl, GiftDataRemove, true); // Ende Remove
        // After Remove, Please Gift Product

        var GiftData = {
          id: parseFloat(window.themeVariables.settings.productFirstAvailible.id),
          quantity: 1,
          "properties": {
            _firstproduct: "1"
          }
        };
        window.count_item = cart.item_count + 1;
        setTimeout(function () {
          setProductOperation(window.themeVariables.routes.cartAddUrl, GiftData, true);
        }, 500);
        addAndDeleteFreeGiftCookie(freeGiftCookiesFirst, '1', '14');
      } else if (getCookieValue(freeGiftCookiesLast) != 0 && cart.total_price >= minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) == null) {
        // Please remove the Gift Product first
        var _GiftDataRemove = {
          id: "" + parseFloat(window.themeVariables.settings.productLastAvailible.id),
          quantity: 0
        };
        setProductOperation(window.themeVariables.routes.cartAddUrl, _GiftDataRemove, true); // after remove Product, Please add Gift product to the cart

        var _GiftData = {
          id: parseFloat(window.themeVariables.settings.productLastAvailible.id),
          quantity: 1,
          "properties": {
            _lastproduct: "1"
          }
        };
        window.count_item = cart.item_count + 1;
        setTimeout(function () {
          setProductOperation(window.themeVariables.routes.cartAddUrl, _GiftData, true);
        }, 500);
        addAndDeleteFreeGiftCookie(freeGiftCookiesLast, '1', '14');
      }

      if (cart.total_price < minimum_amount_one && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) != null) {
        //reset the product variant mobile
        if (window.themeVariables.settings.productFirstAvailible.id) {
          var _GiftData2 = {
            id: "" + parseFloat(window.themeVariables.settings.productFirstAvailible.id),
            quantity: 0,
            "properties": {
              _firstproduct: "0"
            }
          };
          window.count_item = cart.item_count - 1;
          setProductOperation(window.themeVariables.routes.cartChangeUrl, _GiftData2, true); // addAndDeleteFreeGiftCookie(freeGiftCookiesFirst,'0','1');
        }
      }

      if (cart.total_price > minimum_amount_one && cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) != null) {
        //reset the product variant mobile
        if (window.themeVariables.settings.productLastAvailible.id) {
          var _GiftData3 = {
            id: "" + parseFloat(window.themeVariables.settings.productLastAvailible.id),
            quantity: 0,
            "properties": {
              _lastproduct: "0"
            }
          };
          window.count_item = cart.item_count - 1;
          setProductOperation(window.themeVariables.routes.cartChangeUrl, _GiftData3, true); //addAndDeleteFreeGiftCookie(freeGiftCookiesLast,'0','1');
        }
      }
    }
  });
} // Remove Product on Cart Drawer


$(document).on('click', '.drawer__content .remove-gift-product', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
    var _this = this;

    var giftProductId, cookieDelete;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // event.preventDefault();
            fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response2) {
                var cartContent, cart, giftProductId, GiftData;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return response2.json();

                      case 2:
                        cartContent = _context.sent;
                        cart = cartContent; // Get the updated content of the cart

                        giftProductId = $(_this).data('gift-id');
                        GiftData = {
                          id: "" + parseFloat(giftProductId),
                          quantity: 0
                        };
                        window.count_item = cart.item_count - 1;
                        setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
            refreshGiftCart();
            giftProductId = $(this).data('gift-id');
            cookieDelete = "";
            if (window.themeVariables.settings.productFirstAvailible.id == giftProductId) cookieDelete = freeGiftCookiesFirst;else if (window.themeVariables.settings.productLastAvailible.id == giftProductId) cookieDelete = freeGiftCookiesLast;
            addAndDeleteFreeGiftCookie(cookieDelete, '0', '1');

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()); // Add Product on Cart drawer

$(document).on('click', '.drawer__content .add-gift-product', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
    var _this2 = this;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // event.preventDefault();
            fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response2) {
                var cartContent, cart, giftProductId, GiftData, cookieAdd;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return response2.json();

                      case 2:
                        cartContent = _context3.sent;
                        cart = cartContent; // Get the updated content of the cart

                        giftProductId = $(_this2).data('gift-id');
                        GiftData = {
                          id: parseFloat(giftProductId),
                          quantity: 1
                        };
                        window.count_item = cart.item_count - 1;
                        setProductOperation(window.themeVariables.routes.cartAddUrl, GiftData, true);
                        cookieAdd = "";
                        if (window.themeVariables.settings.productFirstAvailible.id == giftProductId) cookieAdd = freeGiftCookiesFirst;else if (window.themeVariables.settings.productLastAvailible.id == giftProductId) cookieAdd = freeGiftCookiesLast;
                        addAndDeleteFreeGiftCookie(cookieAdd, '1', '14');

                      case 11:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref4.apply(this, arguments);
              };
            }());
            refreshGiftCart();

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());
$(document).on('click', 'button.checkout-button', function (event) {
  var _this3 = this;

  event.preventDefault();
  refreshGiftCart();
  setTimeout(function () {
    return _this3.form.submit();
  }, 250);
}); ////////////////////////////////////////////////
//////// Cart Page ///////////////////////////
// Remove Product on Cart page

$(document).on('click', '.cart .remove-gift-product', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(event) {
    var _this4 = this;

    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            // event.preventDefault();
            fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(response2) {
                var cartContent, cart, giftProductId, GiftData, cookieDelete;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return response2.json();

                      case 2:
                        cartContent = _context5.sent;
                        cart = cartContent; // Get the updated content of the cart

                        giftProductId = $(_this4).data('gift-id');
                        GiftData = {
                          id: "" + parseFloat(giftProductId),
                          quantity: 0
                        };
                        window.count_item = cart.item_count - 1;
                        setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
                        cookieDelete = "";
                        if (window.themeVariables.settings.productFirstAvailible.id == giftProductId) cookieDelete = freeGiftCookiesFirst;else if (window.themeVariables.settings.productLastAvailible.id == giftProductId) cookieDelete = freeGiftCookiesLast;
                        addAndDeleteFreeGiftCookie(cookieDelete, '0', '1');

                      case 11:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x6) {
                return _ref6.apply(this, arguments);
              };
            }());
            setTimeout(function () {
              refreshGiftCart();
              location.reload();
            }, 500);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x5) {
    return _ref5.apply(this, arguments);
  };
}()); // Add Product on Cart page

$(document).on('click', '.cart .add-gift-product', /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(event) {
    var _this5 = this;

    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            // event.preventDefault();
            fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(response2) {
                var cartContent, cart, giftProductId, GiftData, cookieAdd;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return response2.json();

                      case 2:
                        cartContent = _context7.sent;
                        cart = cartContent; // Get the updated content of the cart

                        giftProductId = $(_this5).data('gift-id');
                        GiftData = {
                          id: parseFloat(giftProductId),
                          quantity: 1
                        };
                        window.count_item = cart.item_count - 1;
                        setProductOperation(window.themeVariables.routes.cartAddUrl, GiftData, true);
                        cookieAdd = "";
                        if (window.themeVariables.settings.productFirstAvailible.id == giftProductId) cookieAdd = freeGiftCookiesFirst;else if (window.themeVariables.settings.productLastAvailible.id == giftProductId) cookieAdd = freeGiftCookiesLast;
                        addAndDeleteFreeGiftCookie(cookieAdd, '1', '14');

                      case 11:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x8) {
                return _ref8.apply(this, arguments);
              };
            }());
            setTimeout(function () {
              refreshGiftCart();
              location.reload();
            }, 500);

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x7) {
    return _ref7.apply(this, arguments);
  };
}()); // Add / Delete Gift Product from Cart Page

$(document).on('click', '.cart a.quantity-selector__button, .cart .line-item-table-main .line-item__remove-button', /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(event, target) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            addDeleteGitProductFromCartPage(event, target);

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}());
$(document).ready(function () {
  if ($('.product-item__image-wrapper button.button .loader-button__text')) {
    recommendedAddDeleteGitProductFromCartPage();
  }
});

function recommendedAddDeleteGitProductFromCartPage() {
  return _recommendedAddDeleteGitProductFromCartPage.apply(this, arguments);
}

function _recommendedAddDeleteGitProductFromCartPage() {
  _recommendedAddDeleteGitProductFromCartPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (window.themeVariables.settings.pageType == "cart") {
              //check if the client is set a first product for gift
              if (window.count_item > 0
              /* && window.themeVariables.settings.productFirstAvailible.id*/
              ) {
                fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
                  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(response2) {
                    var cartContent, cart, minimum_amount_one, minimum_amount_two, GiftData, _GiftData5;

                    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return response2.json();

                          case 2:
                            cartContent = _context10.sent;
                            cart = cartContent; // Get the updated content of the cart

                            window.count_item = cart.item_count; // update cart items

                            minimum_amount_one = parseFloat(window.themeVariables.settings.productMinumumAmountOne) * 100;
                            minimum_amount_two = parseFloat(window.themeVariables.settings.productMinumumAmountTwo) * 100; //check if the total price greather than to minimum amount and the gift product doesn't exist in the cart

                            if (getCookieValue(freeGiftCookiesFirst) != 0 && cart.total_price >= minimum_amount_one && cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) == null) {
                              GiftData = {
                                id: parseFloat(window.themeVariables.settings.productFirstAvailible.id),
                                quantity: 1,
                                "properties": {
                                  _firstproduct: "1"
                                }
                              };
                              window.count_item = cart.item_count + 1;
                              setProductOperation(window.themeVariables.routes.cartAddUrl, GiftData, true);
                              addAndDeleteFreeGiftCookie(freeGiftCookiesFirst, '1', '14'); // console.log('--re>add-firstid');
                            } else if (getCookieValue(freeGiftCookiesLast) != 0 && cart.total_price >= minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) == null) {
                              _GiftData5 = {
                                id: parseFloat(window.themeVariables.settings.productLastAvailible.id),
                                quantity: 1,
                                "properties": {
                                  _lastproduct: "1"
                                }
                              };
                              window.count_item = cart.item_count + 1;
                              setProductOperation(window.themeVariables.routes.cartAddUrl, _GiftData5, true);
                              addAndDeleteFreeGiftCookie(freeGiftCookiesLast, '1', '14'); // console.log('-re->add-lastid');
                            } // if (cart.total_price < minimum_amount_one && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) != null) {
                            //   //reset the product variant mobile
                            //   if (window.themeVariables.settings.productFirstAvailible.id){
                            //     let GiftData = {
                            //       id: "" + parseFloat(window.themeVariables.settings.productFirstAvailible.id),
                            //       quantity: 0,
                            //       "properties": {
                            //         _firstproduct : "0"
                            //       }
                            //     };
                            //     window.count_item = cart.item_count - 1;
                            //     // setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
                            //     setTimeout(() => {        
                            //       setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
                            //     }, 200);
                            //     console.log('-re->delete-firstid');
                            //   }
                            // } 
                            // if (/*cart.total_price > minimum_amount_one &&*/ cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) != null) {
                            //   //reset the product variant mobile
                            //   if (window.themeVariables.settings.productLastAvailible.id){
                            //       let GiftData = {
                            //         id: "" + parseFloat(window.themeVariables.settings.productLastAvailible.id),
                            //         quantity: 0,
                            //         "properties": {
                            //           _lastproduct : "0"
                            //         }
                            //       };
                            //       window.count_item = cart.item_count - 1;
                            //       // setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
                            //       setTimeout(() => {      
                            //         setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
                            //       }, 400);
                            //       console.log('-re->delete-lastid');
                            //   }
                            // }


                          case 8:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function (_x11) {
                    return _ref10.apply(this, arguments);
                  };
                }());
              }
            }

            refreshGiftCart();

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _recommendedAddDeleteGitProductFromCartPage.apply(this, arguments);
}

function addDeleteGitProductFromCartPage() {
  return _addDeleteGitProductFromCartPage.apply(this, arguments);
} // Remove Element from Cart Page
// $(document).on('click', '.cart .line-item-table-main .line-item__remove-button', async function (event) {
//   setTimeout(() => {
//     refreshGiftCart();
//     location.reload();
//   }, 500);
// });
// Remove Coookie from Gift Product 


function _addDeleteGitProductFromCartPage() {
  _addDeleteGitProductFromCartPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var event,
        target,
        changeUrl,
        link,
        response,
        _response,
        _args13 = arguments;

    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            event = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : null;
            target = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
            url = event.target.href || null;
            parQuantity = $.urlParam(url, 'quantity');
            parLine = $.urlParam(url, 'line');
            parId = $.urlParam(url, 'id');
            changeUrl = "";
            link = "";

            if (!(parLine && parLine != null)) {
              _context13.next = 17;
              break;
            }

            // Change Element width line as Parameter
            link = "".concat(window.themeVariables.routes.cartChangeUrl, "?quantity=").concat(parQuantity, "&line=").concat(parLine);
            changeUrl = new URL(link, "https://".concat(window.themeVariables.routes.host)), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
            this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", {
              bubbles: true,
              detail: {
                newLineQuantity: parQuantity
              }
            }));
            _context13.next = 14;
            return fetch("".concat(window.themeVariables.routes.cartChangeUrl, ".js"), {
              body: JSON.stringify({
                line: line,
                quantity: quantity,
                sections: ["mini-cart"]
              }),
              credentials: "same-origin",
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 14:
            response = _context13.sent;
            _context13.next = 23;
            break;

          case 17:
            // Change Element width id as Parameter
            link = "".concat(window.themeVariables.routes.cartChangeUrl, "?quantity=").concat(parQuantity, "&id=").concat(parId);
            changeUrl = new URL(link, "https://".concat(window.themeVariables.routes.host)), searchParams = changeUrl.searchParams, id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
            this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", {
              bubbles: true,
              detail: {
                newLineQuantity: parQuantity
              }
            }));
            _context13.next = 22;
            return fetch("".concat(window.themeVariables.routes.cartChangeUrl, ".js"), {
              body: JSON.stringify({
                id: id,
                quantity: quantity,
                sections: ["mini-cart"]
              }),
              credentials: "same-origin",
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 22:
            _response = _context13.sent;

          case 23:
            if (window.themeVariables.settings.pageType == "cart") {
              //check if the client is set a first product for gift
              if (window.count_item > 0
              /* && window.themeVariables.settings.productFirstAvailible.id*/
              ) {
                fetch("".concat(window.themeVariables.routes.cartUrl, ".js")).then( /*#__PURE__*/function () {
                  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(response2) {
                    var cartContent, cart, minimum_amount_one, minimum_amount_two, GiftData, _GiftData6, _GiftData7, _GiftData8;

                    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return response2.json();

                          case 2:
                            cartContent = _context12.sent;
                            cart = cartContent; // Get the updated content of the cart

                            window.count_item = cart.item_count; // update cart items

                            minimum_amount_one = parseFloat(window.themeVariables.settings.productMinumumAmountOne) * 100;
                            minimum_amount_two = parseFloat(window.themeVariables.settings.productMinumumAmountTwo) * 100; //check if the total price greather than to minimum amount and the gift product doesn't exist in the cart

                            if (getCookieValue(freeGiftCookiesFirst) != 0 && cart.total_price >= minimum_amount_one && cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) == null) {
                              GiftData = {
                                id: parseFloat(window.themeVariables.settings.productFirstAvailible.id),
                                quantity: 1,
                                "properties": {
                                  _firstproduct: "1"
                                }
                              };
                              window.count_item = cart.item_count + 1;
                              setProductOperation(window.themeVariables.routes.cartAddUrl, GiftData, true);
                              addAndDeleteFreeGiftCookie(freeGiftCookiesFirst, '1', '14'); // console.log('-->add-firstid');
                            } else if (getCookieValue(freeGiftCookiesLast) != 0 && cart.total_price >= minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) == null) {
                              _GiftData6 = {
                                id: parseFloat(window.themeVariables.settings.productLastAvailible.id),
                                quantity: 1,
                                "properties": {
                                  _lastproduct: "1"
                                }
                              };
                              window.count_item = cart.item_count + 1;
                              setProductOperation(window.themeVariables.routes.cartAddUrl, _GiftData6, true);
                              addAndDeleteFreeGiftCookie(freeGiftCookiesLast, '1', '14'); // console.log('-->add-lastid');
                            }

                            if (cart.total_price < minimum_amount_one && getGiftProduct(cart, window.themeVariables.settings.productFirstAvailible.id) != null) {
                              //reset the product variant mobile
                              if (window.themeVariables.settings.productFirstAvailible.id) {
                                _GiftData7 = {
                                  id: "" + parseFloat(window.themeVariables.settings.productFirstAvailible.id),
                                  quantity: 0,
                                  "properties": {
                                    _firstproduct: "0"
                                  }
                                };
                                window.count_item = cart.item_count - 1; // setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);

                                setTimeout(function () {
                                  setProductOperation(window.themeVariables.routes.cartChangeUrl, _GiftData7, true);
                                }, 200); // console.log('-->delete-firstid');
                              }
                            }

                            if (
                            /*cart.total_price > minimum_amount_one &&*/
                            cart.total_price < minimum_amount_two && getGiftProduct(cart, window.themeVariables.settings.productLastAvailible.id) != null) {
                              //reset the product variant mobile
                              if (window.themeVariables.settings.productLastAvailible.id) {
                                _GiftData8 = {
                                  id: "" + parseFloat(window.themeVariables.settings.productLastAvailible.id),
                                  quantity: 0,
                                  "properties": {
                                    _lastproduct: "0"
                                  }
                                };
                                window.count_item = cart.item_count - 1; // setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);

                                setTimeout(function () {
                                  setProductOperation(window.themeVariables.routes.cartChangeUrl, _GiftData8, true);
                                }, 400); // console.log('-->delete-lastid');
                              }
                            }

                          case 10:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  return function (_x12) {
                    return _ref11.apply(this, arguments);
                  };
                }());
              }
            }

            setTimeout(function () {
              refreshGiftCart();
              location.reload();
            }, 500);

          case 25:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));
  return _addDeleteGitProductFromCartPage.apply(this, arguments);
}

function addAndDeleteFreeGiftCookie(key, value, expiry) {
  setCookie(key, value, expiry);
  checkCookies(key);
} // Remove Gift Product, if cart empty 


function removeGiftProductIfTotalPriceNull() {
  // Delete Gift Product, if total price equal 0
  if (isCartPage && cartTotalPrice == 0) {
    if (getGiftProduct(cartItems, window.themeVariables.settings.productFirstAvailible.id) != null || getGiftProduct(cartItems, window.themeVariables.settings.productLastAvailible.id) != null) {
      if (window.themeVariables.settings.productFirstAvailible.id && getGiftProduct(cartItems, window.themeVariables.settings.productFirstAvailible.id) != null) {
        var GiftData = {
          id: "" + parseFloat(window.themeVariables.settings.productFirstAvailible.id),
          quantity: 0
        };
        setProductOperation(window.themeVariables.routes.cartChangeUrl, GiftData, true);
      }

      if (window.themeVariables.settings.productLastAvailible.id && getGiftProduct(cartItems, window.themeVariables.settings.productLastAvailible.id) != null) {
        var _GiftData4 = {
          id: "" + parseFloat(window.themeVariables.settings.productLastAvailible.id),
          quantity: 0
        };
        setProductOperation(window.themeVariables.routes.cartChangeUrl, _GiftData4, true);
      }

      setTimeout(function () {
        checkCookies(freeGiftCookiesFirst);
        checkCookies(freeGiftCookiesLast);
        location.reload();
      }, 500);
    }
  }
} //refresh the cart immediatly


function refreshGiftCart() {
  if (window.themeVariables.settings.pageType == "cart") {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true
    }));
  }
} // Add Product to Cart


function setProductOperation(endpoint, formData, refreshCart) {
  return fetch(endpoint + ".js", {
    body: JSON.stringify(formData),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header

    }
  }).then(function (cart) {
    cart.json().then(function (content) {
      if (refreshCart) {
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
          }));
        }, 1000);
      }
    });
  });
} // Check Gift Product. @return GiftProduct


function getGiftProduct(cart, productID) {
  var productGift = null;
  cart.items.forEach(function (product) {
    if (product.id == productID) {
      productGift = product;
    }
  });
  return productGift;
} // CheckCookies Status


function checkCookies(cookieName) {
  if (cookieName == 'perlgift-1' && getCookie("perlgift-1") == null) {
    setCookie("perlgift-1", "-1", 1);
  }

  if (cookieName == 'perlgift-2' && getCookie("perlgift-2") == null) {
    setCookie("perlgift-2", "-1", 1);
  }

  var screenWidth = $(window).width();
  var firstRemoveGiftProduct = $('.line-item-first .remove-gift-product');
  var firstAddGiftProduct = $('.line-item-first .add-gift-product');
  var firstRemoveGiftProductMobile = $('.line-item-first .remove-gift-product-mobile');
  var firstAddGiftProductMobile = $('.line-item-first .add-gift-product-mobile');

  if (cookieName == "perlgift-1" && getCookieValue(cookieName) == 0 && (firstAddGiftProduct.length > 0 || firstRemoveGiftProduct.length > 0)) {
    if (screenWidth < 741) {
      firstRemoveGiftProduct.addClass('hidden-tablet-and-up nodisplay');
      firstAddGiftProduct.addClass('hidden-tablet-and-up');
      firstRemoveGiftProduct.removeClass('hidden-phone');
    } else {
      firstRemoveGiftProductMobile.addClass('hidden-tablet-and-up');
      firstAddGiftProductMobile.addClass('hidden-tablet-and-up');
      firstRemoveGiftProduct.addClass('hidden-phone nodisplay');
    }

    firstAddGiftProduct.removeClass('nodisplay');
    $('.cart .add-gift-product').closest('.line-item-first').find('input.quantity-selector__input').val(0);
  } else if (cookieName == "perlgift-1") {
    if (screenWidth < 741) {
      firstAddGiftProduct.addClass('hidden-tablet-and-up nodisplay');
      firstRemoveGiftProduct.addClass('hidden-tablet-and-up');
      firstRemoveGiftProduct.removeClass('hidden-phone');
    } else {
      firstAddGiftProduct.addClass('hidden-phone nodisplay');
      firstRemoveGiftProduct.addClass('hidden-phone');
      firstRemoveGiftProductMobile.addClass('hidden-tablet-and-up');
      firstAddGiftProductMobile.addClass('hidden-tablet-and-up');
    }

    firstRemoveGiftProduct.removeClass('nodisplay');
    $('.cart .remove-gift-product').closest('.line-item-first').find('input.quantity-selector__input').val(1);
  }

  var lastRemoveGiftProduct = $('.line-item-last .remove-gift-product');
  var lastAddGiftProduct = $('.line-item-last .add-gift-product');
  var lastRemoveGiftProductMobile = $('.line-item-last .remove-gift-product-mobile');
  var lastAddGiftProductMobile = $('.line-item-last .add-gift-product-mobile');

  if (cookieName == "perlgift-2" && getCookieValue(cookieName) == 0 && (lastAddGiftProduct.length > 0 || lastRemoveGiftProduct.length > 0)) {
    if (screenWidth < 741) {
      lastRemoveGiftProduct.addClass('hidden-tablet-and-up nodisplay');
      lastRemoveGiftProduct.removeClass('hidden-phone');
      lastAddGiftProduct.addClass('hidden-tablet-and-up');
    } else {
      lastRemoveGiftProduct.addClass('hidden-phone nodisplay');
      lastAddGiftProduct.addClass('hidden-phone');
      lastRemoveGiftProductMobile.addClass('hidden-tablet-and-up');
      lastAddGiftProductMobile.addClass('hidden-tablet-and-up');
    }

    lastAddGiftProduct.removeClass('nodisplay');
    $('.cart .add-gift-product').closest('.line-item-last').find('input.quantity-selector__input').val(0);
  } else if (cookieName == "perlgift-2") {
    if (screenWidth < 741) {
      lastAddGiftProduct.addClass('hidden-tablet-and-up nodisplay');
      lastRemoveGiftProduct.addClass('hidden-tablet-and-up');
      lastRemoveGiftProduct.removeClass('hidden-phone');
    } else {
      lastAddGiftProduct.addClass('hidden-phone nodisplay');
      lastRemoveGiftProduct.addClass('hidden-phone');
      lastRemoveGiftProductMobile.addClass('hidden-tablet-and-up');
      lastAddGiftProductMobile.addClass('hidden-tablet-and-up');
    }

    lastRemoveGiftProduct.removeClass('nodisplay');
    $('.cart .remove-gift-product').closest('.line-item-last').find('input.quantity-selector__input').val(1);
  }
} // Help function


$.urlParam = function (url, name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);

  if (results == null) {
    return null;
  }

  return decodeURI(results[1]) || 0;
};

function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}

function getCookieValue(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}

function eraseCookie(key) {
  var keyValue = getCookieValue(key);
  setCookie(key, keyValue, '-1');
} // if exist = -1 else null


function getCookie(name) {
  var nameEquals = name + '=';
  var cookieArray = document.cookie.split(';');

  var _iterator = _createForOfIteratorHelper(cookieArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      cookie = _step.value;

      while (cookie.charAt(0) == ' ') {
        cookie = cookie.slice(1, cookie.length);
      }

      if (cookie.indexOf(nameEquals) == 0) return decodeURIComponent(cookie.slice(nameEquals.length, cookie.length));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
/******/ })()
;